import { useRouter } from "lib/router";
import { useEffect, useRef } from "react";

export const useOnPageChange = (onPageChange: (url: string) => void): void => {
  const { beforeUnload } = useRouter();
  const cb = useRef(onPageChange);

  useEffect(() => {
    cb.current = onPageChange;
  }, [onPageChange]);

  useEffect(() => {
    const handleRouteChange = (url) => {
      cb.current(url);
    };

    beforeUnload(handleRouteChange);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
